import { ToastModule } from "primeng/toast";
import { ToolbarModule } from 'primeng/toolbar';
import { ButtonModule } from 'primeng/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { SkeletonModule } from 'primeng/skeleton';
import { DialogModule } from 'primeng/dialog';
import { InputNumberModule } from 'primeng/inputnumber';
import { CheckboxModule } from 'primeng/checkbox';
import { TriStateCheckboxModule } from "primeng/tristatecheckbox";
import { MultiSelectModule } from 'primeng/multiselect';
import { CalendarModule } from 'primeng/calendar';
import { FileUploadModule } from 'primeng/fileupload';
import { ProgressBarModule } from 'primeng/progressbar';
import { TabViewModule } from 'primeng/tabview';
import { TooltipModule } from 'primeng/tooltip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ChipsModule } from 'primeng/chips';
import { DropdownModule } from 'primeng/dropdown';
import { AvatarModule } from 'primeng/avatar';
import { SplitButtonModule } from 'primeng/splitbutton';
import { BadgeModule } from 'primeng/badge';
import { RadioButtonModule } from "primeng/radiobutton";
import { InputMaskModule } from 'primeng/inputmask';
import { KnobModule } from 'primeng/knob';
import { ImageModule } from "primeng/image";
import { SelectButtonModule } from "primeng/selectbutton";
import { ChartModule } from "primeng/chart";

export const PI_MODULES = [
    AvatarModule,
    ButtonModule,
    BadgeModule,
    CheckboxModule,
    ChartModule,
    CalendarModule,
    ConfirmDialogModule,
    ChipsModule,
    DialogModule,
    DropdownModule,
    FileUploadModule,
    FormsModule,
    InputNumberModule,
    InputTextModule,
    InputMaskModule,
    ImageModule,
    KnobModule,
    MultiSelectModule,
    ProgressBarModule,
    ProgressSpinnerModule,
    RadioButtonModule,
    ReactiveFormsModule,
    ToastModule,
    ToolbarModule,
    TableModule,
    TriStateCheckboxModule,
    TabViewModule,
    TooltipModule,
    SkeletonModule,
    SplitButtonModule,
    SelectButtonModule,
]